import { Component, OnDestroy, Output } from '@angular/core';
import { configOption, navData } from './nav-data';
import { CommonModule } from '@angular/common';
import { RouterLink, Router, RouterModule} from '@angular/router';
import { EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../Auth/auth.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { VendorMessagesPulseService } from '../../../Services/vendor-messages-pulse.service';
import { Subject, filter, take, takeUntil } from 'rxjs';

interface SideNavToggle{
  screenWidth: number;
  collapsed: boolean;
}
@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [CommonModule,RouterLink,RouterModule,FormsModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.css'
})
export class SideMenuComponent implements OnDestroy {

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private router: Router,
    private vendorMessagesPulse: VendorMessagesPulseService
  ) {}

  loading: boolean = false;
  unreadVendorMessages = false;
  private readonly destroy$ = new Subject<void>();

  ngOnInit() {
    const token = this.authService.getAccessToken();
    const email = this.authService.getUserEmail();

    if (!token || !email) {
      console.error('User is not logged in or email/token is missing.');
      this.router.navigate(['/']);
      return;
    }

    // Consume shared current user (set by app init or after login); no refetch.
    this.loading = true;
    this.dataService.currentUser$.pipe(
      filter((u): u is NonNullable<typeof u> => u != null),
      take(1)
    ).subscribe({
      next: (user) => {
        this.userType = user.role;
        this.loading = false;
        if (user.role === 'Vendor') {
          this.vendorMessagesPulse.startMonitoring();
          this.vendorMessagesPulse.hasUnread$
            .pipe(takeUntil(this.destroy$))
            .subscribe((v) => (this.unreadVendorMessages = v));
        }
      },
      error: () => {
        this.loading = false;
        this.router.navigate(['/']);
      }
    });
  }
  
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  isExpanded = false;


  screenWidth = 0;
  navbarData = navData;
  logout = configOption;
  data: any;
  userType:any;

  handleLogout(event: Event): void {
    event.preventDefault(); // Prevent page reload or unwanted navigation
    this.authService.logout(); // Call logout function
  }
  
  toggleCollapse() {
  this.isExpanded =!this.isExpanded;
  this.toggle.emit(this.isExpanded);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.vendorMessagesPulse.stopMonitoring();
  }
}
